import { createContext, useContext } from 'react';
import noop, { NoOp } from 'utils/noop';
import { PossibleNodeTypes } from 'ui/treeView';

export enum TestMsgModals {
  None = 'none',
  SendTestAsRandom = 'sendTestAsRandom',
  SendTestToInternalList = 'sendTestToInternalList',
  SendTestToOther = 'sendTestToOther',
  DisplayTestToYourself = 'displayTestToYourself',
  DisplayTestToInternalList = 'displayTestToInternalList',
  DisplayTestToOther = 'displayTestToOther',
}

export type ListOption = {
  doubleLine: string;
  id: string;
  label: string;
  value: number;
};

export type UserData = {
  email?: string;
  userId?: string;
  dataFields: Record<string, PossibleNodeTypes>;
};

export interface SendTestMsgContextState {
  emailListOptions: ListOption[];
  internalListOptions: ListOption[];
  isFetchingLists: boolean;
  isSendingTestMsg: boolean;
  onFetchLists: NoOp;
  onSendTestAsRandom: (id: number, recipient: string, size: number, uuidOrEmail: string) => void;
  onSendTestToInternalList: (id: number) => void;
  onSendTestToOtherEmail: (emails: string[]) => void;
  onSendTestToOtherUserId: (userIds: string[]) => void;
  onSendTestToSelf: NoOp;
  onDisplayTestToInternalList: (id: number, removingDisplayMessage?: boolean) => void;
  onDisplayTestToOtherEmail: (emails: string[], removingDisplayMessage?: boolean) => void;
  onDisplayTestToSelf: (removingDisplayMessage?: boolean) => void;
  openTestMsgModal: TestMsgModals;
  sendTestAsRandomUserData: UserData[];
  setOpenTestMsgModal: (modal: TestMsgModals) => void;
  sendErrors: Record<string, string>;
}

export const SendTestMsgContext = createContext<SendTestMsgContextState>({
  emailListOptions: [],
  internalListOptions: [],
  isFetchingLists: false,
  isSendingTestMsg: false,
  onFetchLists: noop,
  onSendTestAsRandom: noop,
  onSendTestToInternalList: noop,
  onSendTestToOtherEmail: noop,
  onSendTestToOtherUserId: noop,
  onSendTestToSelf: noop,
  onDisplayTestToInternalList: noop,
  onDisplayTestToOtherEmail: noop,
  onDisplayTestToSelf: noop,
  openTestMsgModal: TestMsgModals.None,
  sendTestAsRandomUserData: [],
  setOpenTestMsgModal: noop,
  sendErrors: {},
});

export const useSendTestMsgContext = () => useContext(SendTestMsgContext);
